import { ServiceFetch } from '../service-fetch'

export default class PointExchangeListModel extends ServiceFetch {
    getPointExchangeListBy = (data) => this.authFetch({
        url: 'point-exchange-list/getPointExchangeListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}